import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CollectionDisplaysModalContainerViewModel } from '../collection-displays-modal-container/collection-displays-modal-container-view-model';
import { BaseModalComponent } from '../../../../../models/base/base-modal.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-collection-reload-displays-modal',
  templateUrl: './collection-reload-displays-modal.component.html',
  styleUrls: ['./collection-reload-displays-modal.component.scss'],
  providers: [CollectionDisplaysModalContainerViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CollectionReloadDisplaysModalComponent extends BaseModalComponent {
  constructor(
    protected activeModal: NgbActiveModal,
    public viewModel: CollectionDisplaysModalContainerViewModel
  ) {
    super(activeModal);
  }
}
